import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createTopicRequest = { image: '_image' };
var _createTopicResponse = {};
var _deleteTopicRequest = {};
var _deleteTopicResponse = {};
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _listTopicsRequest = {};
var _listTopicsResponse = { topics: '_topic' };
var _topic = { createdDate: 'google.protobuf.Timestamp', image: '_image' };
var _updateTopicRequest = { image: '_image' };
var _updateTopicResponse = { topic: '_topic' };
function resolveWixTopicsTopicsServiceUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/topics/v1',
                destPath: '/v1',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/topics/_api/v1',
                destPath: '/v1',
            },
        ],
        _: [
            {
                srcPath: '/_api/topics/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/topics/_api/v1',
                destPath: '/v1',
            },
        ],
        'social._base_domain_': [
            {
                srcPath: '/topics/api/v1',
                destPath: '/v1',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/topics/_api/v1',
                destPath: '/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/topics/_api/v1',
                destPath: '/v1',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/topics/_api/v1',
                destPath: '/v1',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/topics/_api/v1',
                destPath: '/v1',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/topics/_api/v1',
                destPath: '/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function listTopics(payload) {
    return function __listTopics(_a) {
        var host = _a.host;
        var toJSON = serializer(_listTopicsRequest, {}).toJSON;
        var fromJSON = serializer(_listTopicsResponse, { _image: _image, _topic: _topic }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixTopicsTopicsServiceUrl({
                protoPath: '/v1/topics',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
export function createTopic(payload) {
    return function __createTopic(_a) {
        var host = _a.host;
        var toJSON = serializer(_createTopicRequest, { _image: _image }).toJSON;
        var fromJSON = serializer(_createTopicResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixTopicsTopicsServiceUrl({
                protoPath: '/v1/topics',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
export function updateTopic(payload) {
    return function __updateTopic(_a) {
        var host = _a.host;
        var toJSON = serializer(_updateTopicRequest, { _image: _image }).toJSON;
        var fromJSON = serializer(_updateTopicResponse, { _image: _image, _topic: _topic }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'PATCH',
            url: resolveWixTopicsTopicsServiceUrl({
                protoPath: '/v1/topics/{id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** delete a comment */
export function deleteTopic(payload) {
    return function __deleteTopic(_a) {
        var host = _a.host;
        var toJSON = serializer(_deleteTopicRequest, {}).toJSON;
        var fromJSON = serializer(_deleteTopicResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'DELETE',
            url: resolveWixTopicsTopicsServiceUrl({
                protoPath: '/v1/topics/{id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
//# sourceMappingURL=http.js.map